module.exports = __webpack_public_path__ + "img/goodbye_ons.3561e72f.png";